export function prettifyPrice(value: number | string | null, currency?: string): string | undefined | null {
    if (value === null) return null

    const num = typeof value === 'string' ? parseFloat(value) : value

    if (typeof value === 'string' && isNaN(num)) {
        return value
    }

    if (isNaN(num)) return undefined

    try {
        return num.toLocaleString('fr-FR', {
            useGrouping: true,
            maximumFractionDigits: 0,
            ...(currency ? { style: 'currency', currency } : {}),
        })
    } catch (e) {
        console.warn('Invalid currency code:', currency, e)
        return num.toLocaleString('fr-FR', {
            useGrouping: true,
            maximumFractionDigits: 0,
        })
    }
}
